import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../Actions/Overlay.action';
import { translate } from '../Services/translation';
import { CaretRight, X } from 'phosphor-react';
import ContactBlock from './ContactBlock';
import { uniqueId } from 'lodash';

const NavigationMegaMenu = ({
  open,
  onMegaMenuClose,
  onMouseOverMegaMenu,
  onMouseLeaveMegaMenu,
  link,
}) => {
  const dispatch = useDispatch();
  const [id] = useState(uniqueId());

  useEffect(() => {
    if (open) {
      dispatch(addOverlay('MegaMenu-' + id, onMegaMenuClose));
    } else {
      dispatch(removeOverlay('MegaMenu-' + id));
    }
  }, [open]);

  return (
    <div
      className={`mega-menu show-for-medium ${open ? 'mega-menu--open' : ''}`}
      onMouseLeave={onMouseLeaveMegaMenu}
      onMouseOver={onMouseOverMegaMenu}
    >
      <div className="row">
        <div className="mega-menu__header">
          <div className="left">
            <div className="mega-menu__header-title">{link.name}</div>
            <a className="mega-menu__header-link" href={link.url}>
              {translate('mega-menu.go-to')} {link.name}{' '}
              <CaretRight size={20} />
            </a>
          </div>
          <div className="right">
            <div className="mega-menu__header-close" onClick={onMegaMenuClose}>
              {translate('general.close')} <X size={20} />
            </div>
          </div>
        </div>
        <div className="mega-menu__content">
          <div className="mega-menu__links-wrapper">
            {link.links?.length > 0 &&
              link.links.map((subLink) => (
                <div
                  key={link.url + subLink.url}
                  className="mega-menu__link-group"
                >
                  <a href={subLink.url}>{subLink.name}</a>
                  {subLink.links?.length > 0 &&
                    subLink.links.map((subSubLink) => (
                      <a
                        key={subLink.url + subSubLink.url}
                        href={subSubLink.url}
                      >
                        {subSubLink.name}
                      </a>
                    ))}
                </div>
              ))}
          </div>
          {!link.showContactBlock && (
            <div className="mega-menu__contact-block">
              <ContactBlock />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationMegaMenu;
